// @flow
/* -----------------Globals--------------- */
import { graphql } from 'react-relay';
import {
  type Bundle,
} from '../types';
import promiseWrapper from '../../PromiseWrapper';

const query = graphql`
  query fetchPremiumContentDetailsQuery($bundleId: Int) {
    bundleDetails(numericId: $bundleId) {
      bundle {
        id
        name
        publisher {
          name
        }
      }
    }
  }
`;

const fetchData = async (
  bundleId: number,
  environment: *,
): Promise<Bundle> => {
  const variables = {
    bundleId,
  };

  const {
    bundleDetails,
  } = await promiseWrapper(query, environment, variables);

  return bundleDetails;
};

export default fetchData;
